export default (props) => (
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" {...props}>
    <path
      d="M10.0417 0.19332L3.455 6.77999L1.135 4.46665C0.875 4.20665 0.455 4.20665 0.195 4.46665C-0.065 4.72665 -0.065 5.14665 0.195 5.40665L2.98167 8.19332C3.24167 8.45332 3.66167 8.45332 3.92167 8.19332L10.9817 1.13999C11.2417 0.879987 11.2417 0.459987 10.9817 0.199987H10.975C10.7217 -0.0666799 10.3017 -0.0666799 10.0417 0.19332Z"
      fill="currentColor"
    />
  </svg>
);
